import { allStatusesEnum } from '../../campaigns/constants';

export default {
  label: 'Pause Campaign',
  value: 'Pause Campaign',
  initialState: () => null,
  patch: () => ({ status: allStatusesEnum.PAUSED.value }),
};
